import { useMantineTheme } from '@mantine/core'
import { useContext } from 'react'

import {
    LightSearchContext,
    LightSearchContextValue,
} from '@/contexts/LightSearchContext'

import React from 'react'
import { RecursiveList, ResultsCounter } from './SearchHitList.components'

const SearchHitList = () => {
    const ctx = useContext(LightSearchContext)

    if (!ctx.results) {
        return null
    }

    return (
        <div>
            <SearchHitListView {...ctx} />
        </div>
    )
}

SearchHitList.displayName = 'SearchHitList'

type SearchHitListViewProps = {
    results: LightSearchContextValue['results']
    count: LightSearchContextValue['count']
    searchQuery: LightSearchContextValue['searchQuery']
}

const SearchHitListView = React.memo(
    ({ results, count, searchQuery }: SearchHitListViewProps) => {
        const { colors } = useMantineTheme()

        return (
            <div
                data-testid="search-bar-hit-list"
                style={{
                    border: `1px solid ${colors.gray[3]}`,
                    zIndex: 999,
                }}
                className="absolute flex flex-col max-h-[60vh]  lg:max-h-[50vh]  bg-white rounded-md shadow-md w-full  w-full mt-1 p-2 overflow-y-auto "
            >
                <ResultsCounter count={count} searchQuery={searchQuery} />
                <div className="grid">
                    <RecursiveList tree={results!} />
                </div>
            </div>
        )
    },
)

SearchHitListView.displayName = 'SearchHitListView'

export default SearchHitList
